import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {Observable, ReplaySubject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {NoteService} from '../../../shared/services/note.service';
import {Note} from '../../../shared/interface/note';
import {ConfirmDialogComponent} from '../../../shared/components/confirm-dialog/confirm-dialog.component';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {UserPermissions} from '../../../shared/interface/user-permissions';
import {AuthService} from '../../../shared/services/auth.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from "@angular/material/sort";
import {Profile} from "../../../shared/interface/profile";

@Component({
  selector: 'app-note-list',
  templateUrl: './note-list.component.html',
  styleUrls: ['./note-list.component.scss']
})
export class NoteListComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() notes: Observable<Note[]>;
  @Input() disableLinks = false;
  @Input() excludeColumns: string[] = [];
  @Output() changed: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  noteDataSource: MatTableDataSource<Note> = new MatTableDataSource<Note>([]);
  displayedColumns: string[] = [
    'typeOfMeeting',
    'meetingDateTime',
    'meetingEndDate',
    'partnerOrOfwca',
    'regionalAsset',
    'tookPlace',
    'createdBy',
    'actions',
  ];
  userPermissions: ReplaySubject<UserPermissions>;
  profile: Profile;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private noteService: NoteService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  ngOnInit(): void {
    this.auth.getProfile()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((profile: Profile) => {
        this.profile = profile;
      });
    this.notes
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((note: Note[]) => this.noteDataSource.data = note);

    this.displayedColumns = this.displayedColumns.filter((e: string) => this.excludeColumns.indexOf(e) === -1);
  }

  ngAfterViewInit(): void {
    this.noteDataSource.paginator = this.paginator;
    this.noteDataSource.sort = this.sort;
    this.sort.active = 'meetingDateTime';
    this.sort.direction = 'desc';
  }

  deleteNote(note: Note): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć notatkę?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.noteService.deleteNote(note.uuid)
          .subscribe(() => {
            this.snack.open('Pomyślnie usunięto notatkę', '', {duration: 2000});
            this.changed.emit(true);
          });
      }
    });
  }
}
